import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

/**
 * Section heading behind the manifest rail (an allowed rail site). h2 at the
 * Ledger section scale (15/600), optional mono eyebrow above, optional
 * `action` slot on the right. Pass `id` to wire `aria-labelledby` on the
 * enclosing section.
 */
export function SectionHeader({
  id,
  eyebrow,
  title,
  action,
  className,
}: {
  /** Set on the h2 for `aria-labelledby` wiring. */
  id?: string
  eyebrow?: string
  title: ReactNode
  action?: ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        'manifest-rail flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1',
        className,
      )}
    >
      <div>
        {eyebrow ? <p className="micro-label">{eyebrow}</p> : null}
        <h2 id={id} className="text-[0.9375rem] font-semibold text-ink">
          {title}
        </h2>
      </div>
      {action ? <div className="flex items-center gap-2">{action}</div> : null}
    </div>
  )
}
